import { ajax } from '@/api'

export default {
    /**
     * 获取正在传输文件列表
     */
    getUploadingTask( ) {
        const url = "mds/lss/falseData/findAll0"
        return ajax({ url })
    },

    /**
     * 暂停
     */
    pauseTask( data ) {
        const url = 'mds/lss/falseData/getOne'

        return ajax({ url, data, method: 'post' })
    },

  /**
   * 获取公共组列表
   */
    queryCommonGroupList( data ) {
    const url = "/commongroup/querycommongroup"
    return ajax({ url, data, method: 'post' })
    },

  editCommonGroup( data ){
    const url = "/group/editcommongroup"
    return ajax({ url, data, method: 'post' })
  },
  editCommonparamDeleteGrouId( data ){
    const url = "/param/editCommonparamDeleteGrouId"
    return ajax({ url, data, method: 'post' })
  },
  delCommonGroup( data ){
    const url = "/group/delcommongroup"
    return ajax({ url, data, method: 'post' })
  },
  queryCommonParamList( data ){
    const url = "/group/querycommonparams"
    return ajax({ url, data, method: 'post' })
  },
  editparamDeleteReferencesId( data ){
    const url = "/param/editparamDeleteReferencesId"
    return ajax({ url, data, method: 'post' })
  },
  queryparamByComm( data ){
    const url = "/param/queryparamByComm"
    return ajax({ url, data, method: 'post' })
  },
  saveCommonParam( data ){
    const url = "/param/savecommonparam"
    return ajax({ url, data, method: 'post' })
  },
  delCommonParam( data ){
    const url = "/param/delcommonparam"
    return ajax({ url, data, method: 'post' })
  },
  exportData( data ){
    const url = "/commongroup/export"
    return ajax({ url, data, method: 'post' })
  },

  querycommongroupparams( data ){
    const url = "/commongroup/querycommongroupparams"
    return ajax({ url, data, method: 'post' })
  },
  saveCommonParamBatch( data ){
    const url = "/param/savecommonparambatch"
    return ajax({ url, data, method: 'post' })
  }

}
